// =======================================================
// QUIZ ADOPTE-LA — Dropdown + Scoring + Full i18n + 45 noms
// =======================================================

(function(){
  // Export global init used by the Liquid section
  window.AdopteLaQuizInit = function(sectionId, opts){
    const ROOT = document.getElementById(`quiz-adopte-la-${sectionId}`);
    if(!ROOT) return;

    // --------- Langue ---------
    const lang = (opts?.langMode === 'manual' ? opts?.lang : (opts?.detected||'fr')) || 'fr';

    // --------- i18n (UI + taglines) ---------
    const I18N = {
      fr: {
        title:'Adopte-la — Trouve le prénom qui lui va à la peau',
        subtitle:'Un quiz sensuel et réfléchi, fondé sur l’étymologie, la sonorité et l’origine des prénoms.',
        placeholder:'— Choisir —',
        reset:'Réinitialiser',
        submit:'Révéler son prénom',
        notice:'Le quiz attribue des points à des attributs précis puis propose le meilleur match parmi 45 prénoms.',
        open_story:'Découvrir son histoire',
        see_top3:'Voir aussi tes 3 âmes sœurs',
        adopt_cta:'Voir la collection',
        alert_all:'Réponds à toutes les questions.',
        top3_prefix:'Tes trois âmes sœurs : ',
        taglineByTag:{
          fr_classique:"Un charme français à se pâmer.",
          fr_lumineuse:"Clarté dorée, douceur qui s’impose.",
          fr_tendre:"Fine tendresse, caresse qui dure.",
          fr_limpide:"Transparence troublante, éclat clair.",
          fr_sauvage:"Douceur sauvage et regard de lionne.",
          us_iconique:"Présence iconique, désir assumé.",
          us_vivante:"Pleine de vie, vibrante sur ta peau.",
          us_lunaire:"Magnétique, éclairée par la lune.",
          us_enflammée:"Écarlate et audacieuse — brûlante.",
          us_modern:"Moderne, urbaine, irrésistible.",
          it_nobile:"Noble chaleur, baiser italien.",
          it_majestueuse:"Majesté tendre, passion classique.",
          it_lumineuse:"Lumière italienne, douceur solaire.",
          it_libera:"Libre, ardente, pleine de vie.",
          it_protectrice:"T’enlace et te protège de ses bras.",
          de_clarté:"Feu calme, clarté qui rassure.",
          de_gracieuse:"Gracieuse, sûre, désarmante.",
          de_perle:"Rare comme une perle sur ta peau.",
          de_digne:"Sobre et captivante, digne de toi.",
          de_cristal:"Froide en surface, brûlante dedans.",
          jp_tendre:"Amour délicat, attachement soyeux.",
          jp_fleur:"Fleur éphémère, souvenir éternel.",
          jp_jasmin:"Parfum doux, désir persistant.",
          jp_bourgeon:"Éveil des sens, peau frémissante.",
          jp_eblouissante:"Éclosion du désir, douceur japonaise.",
          ru_espoir:"Promesse tenue, désir apaisé.",
          ru_tsarine:"Prestance de tsarine, feu glacé.",
          ru_renaissance:"Renaît à chaque nuit sur toi.",
          ru_paix:"Silence, paix… et frissons.",
          ru_foi:"Fidélité ardente, sans soumission.",
          ca_sage:"Intelligence sensuelle, malice douce.",
          ca_vitale:"Vitalité chaleureuse, étreinte pleine.",
          ca_soyeuse:"Soin appliqué au plaisir, peau soyeuse.",
          ca_androgyne:"Grâce fluide, séduction libre.",
          ca_fraiche:"Fraîcheur naturelle, souffle vert.",
          au_incandescente:"Rubis incandescent, envie immédiate.",
          au_chaleur:"Ambre chaud, caresse résinée.",
          au_aurore:"Rosée du matin, éveil humide.",
          au_douceur:"Olive de paix, douceur charnelle.",
          au_harmonie:"Harmonie du souffle et du rythme.",
          af_sincere:"Sincérité vraie, sensualité honnête.",
          af_belle:"Beauté solaire, éclat sur ta peau.",
          af_intention:"Désir décidé, but assumé.",
          af_nocturne:"Nuit profonde, amante enveloppante.",
          af_eternelle:"Beauté indélébile et chaleur profonde."
        }
      },
      en: {
        title:'Adopt her — Find the name that fits her skin',
        subtitle:'A sensual, thoughtful quiz based on name etymology, sound and origin.',
        placeholder:'— Select —',
        reset:'Reset',
        submit:'Reveal her name',
        notice:'The quiz scores attributes and suggests the best match among 45 names.',
        open_story:'Discover her story',
        see_top3:'See your top 3 soulmates',
        adopt_cta:'Browse the collection',
        alert_all:'Please answer all questions.',
        top3_prefix:'Your three soulmates: ',
        taglineByTag:{
          fr_classique:"French charm, sweet as a sigh.",
          fr_lumineuse:"Golden clarity, gentle heat.",
          fr_tendre:"Tender finesse, a lasting caress.",
          fr_limpide:"Crystal-clear, disarmingly pure.",
          fr_sauvage:"Wild sweetness, a lioness gaze.",
          us_iconique:"Iconic presence, desire declared.",
          us_vivante:"Full of life, buzzing on your skin.",
          us_lunaire:"Magnetic, moon-lit allure.",
          us_enflammée:"Scarlet audacity — burning bright.",
          us_modern:"Modern, urban, irresistible.",
          it_nobile:"Noble warmth, Italian kiss.",
          it_majestueuse:"Majestic and tender — classic fire.",
          it_lumineuse:"Italian light, sun-kissed softness.",
          it_libera:"Free, passionate, and alive.",
          it_protectrice:"Arms that hold and shelter.",
          de_clarté:"Calm fire, reassuring clarity.",
          de_gracieuse:"Graceful, sure, disarming.",
          de_perle:"Rare as a pearl on your skin.",
          de_digne:"Sober, captivating, worthy of you.",
          de_cristal:"Cool to the touch, burning inside.",
          jp_tendre:"Delicate love, silky bond.",
          jp_fleur:"Brief flower, endless memory.",
          jp_jasmin:"Soft fragrance, persistent desire.",
          jp_bourgeon:"Awakening senses, tingling skin.",
          jp_eblouissante:"Slow bloom, a fresh thrill.",
          ru_espoir:"Promise kept, calmed desire.",
          ru_tsarine:"Tsarina poise, icy fire.",
          ru_renaissance:"Born anew each night with you.",
          ru_paix:"Quiet peace… and shivers.",
          ru_foi:"Fervent loyalty, never meek.",
          ca_sage:"Sensual wit, gentle mischief.",
          ca_vitale:"Warm vitality, full embrace.",
          ca_soyeuse:"Skilled care for velvet pleasure.",
          ca_androgyne:"Fluid grace, free seduction.",
          ca_fraiche:"Natural freshness, green breath.",
          au_incandescente:"Incandescent ruby, instant want.",
          au_chaleur:"Amber warmth, resinous touch.",
          au_aurore:"Morning dew, wet awakening.",
          au_douceur:"Olive-peace, carnal softness.",
          au_harmonie:"Breath and rhythm in harmony.",
          af_sincere:"True sincerity, honest sensuality.",
          af_belle:"Solar beauty, glow on skin.",
          af_intention:"Decided desire, chosen aim.",
          af_nocturne:"Deep night, enveloping lover.",
          af_eternelle:"Timeless beauty, deep warmth."
        }
      },
      de: {
        title:'Adoptiere sie — Finde den Namen, der zu ihrer Haut passt',
        subtitle:'Ein sinnliches, durchdachtes Quiz basierend auf Etymologie, Klang und Herkunft.',
        placeholder:'— Wählen —',
        reset:'Zurücksetzen',
        submit:'Ihren Namen enthüllen',
        notice:'Das Quiz bewertet Attribute und schlägt das beste Match unter 45 Namen vor.',
        open_story:'Ihre Geschichte entdecken',
        see_top3:'Top-3 Seelenverwandte ansehen',
        adopt_cta:'Zur Kollektion',
        alert_all:'Bitte beantworte alle Fragen.',
        top3_prefix:'Deine drei Seelenverwandten: ',
        taglineByTag:{
          fr_classique:"Französischer Zauber, zart wie ein Seufzer.",
          fr_lumineuse:"Goldene Klarheit, sanfte Wärme.",
          fr_tendre:"Zarte Finesse, anhaltende Berührung.",
          fr_limpide:"Kristallklar, entwaffnend rein.",
          fr_sauvage:"Wilde Sanftheit, Blick einer Löwin.",
          us_iconique:"Ikonische Präsenz, erklärtes Begehren.",
          us_vivante:"Voller Leben, kribbelnd auf der Haut.",
          us_lunaire:"Magnetisch, vom Mond geküsst.",
          us_enflammée:"Scharlachrote Kühnheit — lodernd.",
          us_modern:"Modern, urban, unwiderstehlich.",
          it_nobile:"Edle Wärme, italienischer Kuss.",
          it_majestueuse:"Majestätisch und zart — klassisches Feuer.",
          it_lumineuse:"Italienisches Licht, sonnige Sanftheit.",
          it_libera:"Frei, leidenschaftlich, lebendig.",
          it_protectrice:"Umarme dich, beschützend und warm.",
          de_clarté:"Ruhiges Feuer, beruhigende Klarheit.",
          de_gracieuse:"Anmutig, sicher, entwaffnend.",
          de_perle:"Selten wie eine Perle auf deiner Haut.",
          de_digne:"Schlicht, fesselnd, deiner würdig.",
          de_cristal:"Kühl außen, innen brennend.",
          jp_tendre:"Zarte Liebe, seidige Bindung.",
          jp_fleur:"Kurze Blüte, ewige Erinnerung.",
          jp_jasmin:"Sanfter Duft, bleibendes Begehren.",
          jp_bourgeon:"Erwachende Sinne, prickelnde Haut.",
          jp_eblouissante:"Langsame Blüte, frischer Nervenkitzel.",
          ru_espoir:"Gehaltenes Versprechen, beruhigtes Begehren.",
          ru_tsarine:"Zarenpoise, eisiges Feuer.",
          ru_renaissance:"Jede Nacht neu geboren.",
          ru_paix:"Stille, Frieden… und Schauer.",
          ru_foi:"Glühende Treue, nie gefügig.",
          ca_sage:"Sinnige Klugheit, sanfter Schalk.",
          ca_vitale:"Warme Vitalität, volle Umarmung.",
          ca_soyeuse:"Feines Handwerk für Samtgenuss.",
          ca_androgyne:"Fließende Anmut, freie Verführung.",
          ca_fraiche:"Natürliche Frische, grüner Atem.",
          au_incandescente:"Glühender Rubin, sofortiges Begehren.",
          au_chaleur:"Bernsteinwärme, harziger Touch.",
          au_aurore:"Morgentau, feuchtes Erwachen.",
          au_douceur:"Olivenfrieden, fleischliche Sanftheit.",
          au_harmonie:"Atem und Rhythmus in Harmonie.",
          af_sincere:"Wahre Aufrichtigkeit, ehrliche Sinnlichkeit.",
          af_belle:"Sonnenhafte Schönheit, Glanz auf der Haut.",
          af_intention:"Entschiedenes Begehren, gewähltes Ziel.",
          af_nocturne:"Tiefe Nacht, umhüllende Geliebte.",
          af_eternelle:"Zeitlose Schönheit, tiefe Wärme."
        }
      }
    };

    // --------- Traduction des champs depuis DATA ---------
    const TRANSLATE = {
      en: {
        // régions
        "France":"France","USA":"USA","Italie":"Italy","Allemagne":"Germany",
        "Japon/Asie":"Japan/Asia","Russie/Nordique":"Russia/Nordic","Canada":"Canada",
        "Australie":"Australia","Afrique":"Africa",
        // tonalités
        "latine":"Latin","hébraïque":"Hebrew","greco-latine":"Greco-Latin","grecque":"Greek","anglaise":"English",
        "germanique":"Germanic","japonaise":"Japanese","sino-japonaise":"Sino-Japanese",
        "slavo-russe":"Slavo-Russian","slave":"Slavic","grecque/fr":"Greek/French","anglo-fr":"Anglo-French","grecque/russe":"Greek/Russian",
        // longueurs
        "court":"short","moyen":"medium","long":"long",
        // caractère
        "douce":"soft","mystique":"mystical","ardente":"fiery","nordique":"icy","libre":"free","classique":"classic","équilibrée":"balanced","protectrice":"protective",
        // symbolique (toutes utilisées dans les 45)
        "grâce":"grace","lumière":"light","amour":"love","force":"strength","présence":"presence","vie":"life","nuit":"night","feu":"fire",
        "modernité":"modernity","noblesse":"nobility","dévotion":"devotion","liberté":"freedom","paix":"peace","pureté":"purity","beauté":"beauty",
        "parfum":"fragrance","renouveau":"renewal","printemps":"spring","espoir":"hope","renaissance":"rebirth","honneur":"honor","foi":"faith",
        "sagesse":"wisdom","délicatesse":"delicacy","équilibre":"balance","chaleur":"warmth","harmonie":"harmony","rosée":"dew","sincérité":"sincerity",
        "intention":"intention","éternité":"eternity"
      },
      de: {
        "France":"Frankreich","USA":"USA","Italie":"Italien","Allemagne":"Deutschland",
        "Japon/Asie":"Japan/Asien","Russie/Nordique":"Russland/Nordisch","Canada":"Kanada",
        "Australie":"Australien","Afrique":"Afrika",
        "latine":"lateinisch","hébraïque":"hebräisch","greco-latine":"griechisch-lateinisch","grecque":"griechisch","anglaise":"englisch",
        "germanique":"germanisch","japonaise":"japanisch","sino-japonaise":"sino-japanisch",
        "slavo-russe":"slawo-russisch","slave":"slawisch","grecque/fr":"griechisch/französisch","anglo-fr":"anglo-französisch","grecque/russe":"griechisch/russisch",
        "court":"kurz","moyen":"mittel","long":"lang",
        "douce":"sanft","mystique":"mystisch","ardente":"feurig","nordique":"eisig","libre":"frei","classique":"klassisch","équilibrée":"ausgeglichen","protectrice":"beschützend",
        "grâce":"Anmut","lumière":"Licht","amour":"Liebe","force":"Kraft","présence":"Ausstrahlung","vie":"Leben","nuit":"Nacht","feu":"Feuer",
        "modernité":"Modernität","noblesse":"Adel","dévotion":"Hingabe","liberté":"Freiheit","paix":"Frieden","pureté":"Reinheit","beauté":"Schönheit",
        "parfum":"Duft","renouveau":"Erneuerung","printemps":"Frühling","espoir":"Hoffnung","renaissance":"Wiedergeburt","honneur":"Ehre","foi":"Glaube",
        "sagesse":"Weisheit","délicatesse":"Zartheit","équilibre":"Gleichgewicht","chaleur":"Wärme","harmonie":"Harmonie","rosée":"Tau","sincérité":"Aufrichtigkeit",
        "intention":"Absicht","éternité":"Ewigkeit"
      }
    };
    const tr = (txt)=> TRANSLATE[lang]?.[txt] || txt;

    // --------- DATA: 45 prénoms ---------
    const DATA = [
      {"prenom":"Élise","region":"France","tonalite":"latine","longueur":"moyen","caractere":"douce","symbolique":"grâce","etymologie":"De Élisabeth, « serment »; délicatesse fidèle.","tag":"fr_classique"},
      {"prenom":"Aurélie","region":"France","tonalite":"latine","longueur":"long","caractere":"équilibrée","symbolique":"lumière","etymologie":"Du latin aureus, « doré »; chaleur rayonnante.","tag":"fr_lumineuse"},
      {"prenom":"Mila","region":"France","tonalite":"slave","longueur":"court","caractere":"douce","symbolique":"amour","etymologie":"Racine mil-, « aimée, chère »; tendresse simple.","tag":"fr_tendre"},
      {"prenom":"Clara","region":"France","tonalite":"latine","longueur":"moyen","caractere":"équilibrée","symbolique":"lumière","etymologie":"Clarus, « clair, lumineux »; pureté sensuelle.","tag":"fr_limpide"},
      {"prenom":"Léa","region":"France","tonalite":"hébraïque","longueur":"court","caractere":"libre","symbolique":"force","etymologie":"Lecture double: « fatiguée » ou « lionne »; douceur sauvage.","tag":"fr_sauvage"},

      {"prenom":"Samantha","region":"USA","tonalite":"anglaise","longueur":"long","caractere":"classique","symbolique":"présence","etymologie":"Autour de shem « nom »; charisme entendu sans paroles.","tag":"us_iconique"},
      {"prenom":"Ava","region":"USA","tonalite":"hébraïque","longueur":"court","caractere":"ardente","symbolique":"vie","etymologie":"De ḥavvah, « vivre »; vitalité charnelle.","tag":"us_vivante"},
      {"prenom":"Luna","region":"USA","tonalite":"latine","longueur":"court","caractere":"mystique","symbolique":"nuit","etymologie":"Luna, « lune »; éclat nocturne et magnétique.","tag":"us_lunaire"},
      {"prenom":"Scarlett","region":"USA","tonalite":"anglaise","longueur":"long","caractere":"ardente","symbolique":"feu","etymologie":"Scarlet, « écarlate »; passion flamboyante.","tag":"us_enflammée"},
      {"prenom":"Madison","region":"USA","tonalite":"anglaise","longueur":"long","caractere":"libre","symbolique":"modernité","etymologie":"« Fils de Maud » devenu prénom; audace urbaine.","tag":"us_modern"},

      {"prenom":"Giulia","region":"Italie","tonalite":"latine","longueur":"moyen","caractere":"ardente","symbolique":"noblesse","etymologie":"De Julius; chaleur noble et sensuelle.","tag":"it_nobile"},
      {"prenom":"Isabella","region":"Italie","tonalite":"latine","longueur":"long","caractere":"classique","symbolique":"dévotion","etymologie":"Forme d’Élisabeth; dévotion au plaisir.","tag":"it_majestueuse"},
      {"prenom":"Chiara","region":"Italie","tonalite":"latine","longueur":"moyen","caractere":"douce","symbolique":"lumière","etymologie":"« Claire, lumineuse »; transparence troublante.","tag":"it_lumineuse"},
      {"prenom":"Francesca","region":"Italie","tonalite":"latine","longueur":"long","caractere":"libre","symbolique":"liberté","etymologie":"Franciscus, « libre »; mène la danse.","tag":"it_libera"},
      {"prenom":"Alessia","region":"Italie","tonalite":"greco-latine","longueur":"moyen","caractere":"protectrice","symbolique":"force","etymologie":"D’Alexandra; douceur qui protège.","tag":"it_protectrice"},

      {"prenom":"Lena","region":"Allemagne","tonalite":"grecque","longueur":"court","caractere":"équilibrée","symbolique":"lumière","etymologie":"D’Hélène, « torche »; feu calme.","tag":"de_clarté"},
      {"prenom":"Anja","region":"Allemagne","tonalite":"slave","longueur":"court","caractere":"douce","symbolique":"grâce","etymologie":"Variante d’Anna, « grâce »; naturelle, désarmante.","tag":"de_gracieuse"},
      {"prenom":"Greta","region":"Allemagne","tonalite":"germanique","longueur":"court","caractere":"nordique","symbolique":"beauté","etymologie":"De Margareta, « perle »; rare et lumineuse.","tag":"de_perle"},
      {"prenom":"Nora","region":"Allemagne","tonalite":"latine","longueur":"court","caractere":"classique","symbolique":"honneur","etymologie":"D’Honorata; sobre, captivante.","tag":"de_digne"},
      {"prenom":"Elsa","region":"Allemagne","tonalite":"germanique","longueur":"court","caractere":"nordique","symbolique":"pureté","etymologie":"Hypocoristique d’Élisabeth; glacée, brûlante dessous.","tag":"de_cristal"},

      {"prenom":"Aiko","region":"Japon/Asie","tonalite":"japonaise","longueur":"court","caractere":"douce","symbolique":"amour","etymologie":"愛子, « enfant de l’amour »; attachement tendre.","tag":"jp_tendre"},
      {"prenom":"Hana","region":"Japon/Asie","tonalite":"japonaise","longueur":"court","caractere":"douce","symbolique":"beauté","etymologie":"花, « fleur »; grâce éphémère, inoubliable.","tag":"jp_fleur"},
      {"prenom":"Rina","region":"Japon/Asie","tonalite":"japonaise","longueur":"court","caractere":"équilibrée","symbolique":"parfum","etymologie":"莉奈, « jasmin gracieux »; douceur obsédante.","tag":"jp_jasmin"},
      {"prenom":"Mei","region":"Japon/Asie","tonalite":"sino-japonaise","longueur":"court","caractere":"mystique","symbolique":"renouveau","etymologie":"芽衣, « bourgeon »; éveil des sens.","tag":"jp_bourgeon"},
      {"prenom":"Sakura","region":"Japon/Asie","tonalite":"japonaise","longueur":"moyen","caractere":"mystique","symbolique":"printemps","etymologie":"桜, « cerisier en fleurs »; éclosion du désir.","tag":"jp_eblouissante"},

      {"prenom":"Nadia","region":"Russie/Nordique","tonalite":"slavo-russe","longueur":"moyen","caractere":"équilibrée","symbolique":"espoir","etymologie":"Nadezhda, « espoir »; promesse tenue.","tag":"ru_espoir"},
      {"prenom":"Tatiana","region":"Russie/Nordique","tonalite":"latine/russe","longueur":"long","caractere":"nordique","symbolique":"noblesse","etymologie":"De Tatius; prestance de tsarine.","tag":"ru_tsarine"},
      {"prenom":"Anastasia","region":"Russie/Nordique","tonalite":"grecque/russe","longueur":"long","caractere":"mystique","symbolique":"renaissance","etymologie":"« Résurrection »; renaît à chaque nuit.","tag":"ru_renaissance"},
      {"prenom":"Irina","region":"Russie/Nordique","tonalite":"grecque/russe","longueur":"moyen","caractere":"nordique","symbolique":"paix","etymologie":"Eirênê, « paix »; calme qui trouble.","tag":"ru_paix"},
      {"prenom":"Vera","region":"Russie/Nordique","tonalite":"slavonne","longueur":"court","caractere":"classique","symbolique":"foi","etymologie":"« Foi »; fidélité ardente, sans soumission.","tag":"ru_foi"},

      {"prenom":"Sophie","region":"Canada","tonalite":"grecque/fr","longueur":"moyen","caractere":"classique","symbolique":"sagesse","etymologie":"Sophia, « sagesse »; intelligence sensuelle.","tag":"ca_sage"},
      {"prenom":"Évelyne","region":"Canada","tonalite":"anglo-fr","longueur":"long","caractere":"équilibrée","symbolique":"vie","etymologie":"Évolution d’Evelyn; vitalité chaleureuse.","tag":"ca_vitale"},
      {"prenom":"Amélie","region":"Canada","tonalite":"germanique/fr","longueur":"moyen","caractere":"douce","symbolique":"délicatesse","etymologie":"De amal, « zèle »; soin appliqué au plaisir.","tag":"ca_soyeuse"},
      {"prenom":"Camille","region":"Canada","tonalite":"latine","longueur":"moyen","caractere":"libre","symbolique":"équilibre","etymologie":"Camillus; grâce androgyne, fluide.","tag":"ca_androgyne"},
      {"prenom":"Chloé","region":"Canada","tonalite":"grecque","longueur":"moyen","caractere":"libre","symbolique":"renouveau","etymologie":"Chlôros, « verdure »; fraîcheur naturelle.","tag":"ca_fraiche"},

      {"prenom":"Ruby","region":"Australie","tonalite":"anglaise","longueur":"court","caractere":"ardente","symbolique":"feu","etymologie":"Rubis; éclat charnel et vitalité.","tag":"au_incandescente"},
      {"prenom":"Amber","region":"Australie","tonalite":"anglaise","longueur":"moyen","caractere":"douce","symbolique":"chaleur","etymologie":"Ambre; douceur résinée, peau chaude.","tag":"au_chaleur"},
      {"prenom":"Tahlia","region":"Australie","tonalite":"hébraïque/aborigène","longueur":"moyen","caractere":"libre","symbolique":"rosée","etymologie":"« Rosée du matin »; fraîcheur humide, éveil.","tag":"au_aurore"},
      {"prenom":"Olivia","region":"Australie","tonalite":"latine","longueur":"moyen","caractere":"équilibrée","symbolique":"paix","etymologie":"Olive; douceur pacifiante et charnelle.","tag":"au_douceur"},
      {"prenom":"Harper","region":"Australie","tonalite":"anglaise","longueur":"moyen","caractere":"classique","symbolique":"harmonie","etymologie":"« Harpiste »; joue du souffle et du rythme.","tag":"au_harmonie"},

      {"prenom":"Amina","region":"Afrique","tonalite":"arabe","longueur":"moyen","caractere":"équilibrée","symbolique":"sincérité","etymologie":"« Honnête, digne de confiance »; sensualité vraie.","tag":"af_sincere"},
      {"prenom":"Zuri","region":"Afrique","tonalite":"swahili","longueur":"court","caractere":"ardente","symbolique":"beauté","etymologie":"« Belle » en swahili; éclat solaire.","tag":"af_belle"},
      {"prenom":"Nia","region":"Afrique","tonalite":"swahili","longueur":"court","caractere":"libre","symbolique":"intention","etymologie":"« But, intention »; désir décidé.","tag":"af_intention"},
      {"prenom":"Layla","region":"Afrique","tonalite":"arabe","longueur":"moyen","caractere":"mystique","symbolique":"nuit","etymologie":"« Nuit »; amante magnétique, enveloppante.","tag":"af_nocturne"},
      {"prenom":"Amara","region":"Afrique","tonalite":"igbo/afro-latine","longueur":"moyen","caractere":"classique","symbolique":"éternité","etymologie":"« Éternelle »; trace indélébile sur la peau.","tag":"af_eternelle"}
    ];

    // --------- SCORING ---------
    const SCORING = {
      q1:{douce:{caractere:['douce']},mystique:{caractere:['mystique']},ardente:{caractere:['ardente']},nordique:{caractere:['nordique']},libre:{caractere:['libre']},classique:{caractere:['classique','équilibrée']}},
      q2:{court_doux:{longueur:['court'],caractere:['douce']},fluide_aerien:{longueur:['moyen'],caractere:['équilibrée','mystique']},energique:{caractere:['ardente']},tranchante:{caractere:['nordique','classique']}},
      q3:{jp_asie:{region:['Japon/Asie']},eu_nord:{region:['Allemagne','Russie/Nordique']},italie_med:{region:['Italie']},afrique:{region:['Afrique']},fr_occident:{region:['France','USA','Canada','Australie']}},
      q4:{draps_blancs:{caractere:['douce','équilibrée']},ombre:{caractere:['mystique']},assurance:{caractere:['ardente','classique']},regard_froid:{caractere:['nordique']},rire_libre:{caractere:['libre']}},
      q5:{court:{longueur:['court']},moyen:{longueur:['moyen']},long:{longueur:['long']}},
      q6:{amour_grace:{symbolique:['amour','grâce']},nuit_mystere:{symbolique:['nuit','printemps','renouveau']},feu_passion:{symbolique:['feu','vie']},force_honneur:{symbolique:['force','honneur','noblesse','paix']},liberte:{symbolique:['liberté','modernité']}},
      q7:{rose:{symbolique:['amour','grâce']},bleu_nuit:{symbolique:['nuit','printemps']},rouge:{symbolique:['feu','vie']},argent:{symbolique:['paix','lumière']},or:{symbolique:['lumière','noblesse']}},
      q8:{console:{caractere:['douce','équilibrée']},fait_rever:{caractere:['mystique']},domine:{caractere:['ardente','classique']},observe:{caractere:['nordique','classique']},explore:{caractere:['libre']}}
    };

    function scorePrenom(answers){
      const points = new Map(); for(const it of DATA) points.set(it.prenom,0);
      function add(f){
        for(const it of DATA){
          let a=0;
          if(f.caractere && f.caractere.includes(it.caractere)) a++;
          if(f.longueur  && f.longueur.includes(it.longueur))   a++;
          if(f.symbolique&& f.symbolique.includes(it.symbolique)) a++;
          if(f.region    && f.region.includes(it.region))       a++;
          points.set(it.prenom, points.get(it.prenom)+a);
        }
      }
      Object.entries(answers).forEach(([q,v])=>{ const r=SCORING[q]?.[v]; if(r) add(r); });
      // petits bonus
      if(answers.q2==='court_doux'&&answers.q5==='court'){
        for(const it of DATA){ if(it.longueur==='court') points.set(it.prenom, points.get(it.prenom)+1); }
      }
      if(answers.q3==='fr_occident'){
        for(const it of DATA){ if(['classique','équilibrée'].includes(it.caractere)) points.set(it.prenom, points.get(it.prenom)+1); }
      }
      return [...points.entries()].sort((a,b)=>b[1]-a[1]);
    }

    // --------- Rendering helpers ---------
    function pillText(item){
      const r = tr(item.region);
      const L = tr(item.longueur);
      const c = tr(item.caractere);
      const s = tr(item.symbolique);
      return `<span class="pill">${r}</span><span class="pill">${L}</span><span class="pill">${c}</span><span class="pill">${s}</span>`;
    }
    function buildTagline(item){
      const line = I18N[lang]?.taglineByTag?.[item.tag];
      return line || item.etymologie || '';
    }

    // --------- i18n UI ---------
    (function applyI18n(){
      const d = I18N[lang] || I18N.fr;
      ROOT.querySelectorAll('[data-i18n]').forEach(el=>{
        const k = el.getAttribute('data-i18n'); if(d[k]) el.textContent = d[k];
      });
      ROOT.querySelectorAll('select.opt option[data-i18n="placeholder"]').forEach(o=>o.textContent = d.placeholder);
      const closeBtn = ROOT.querySelector(`#closePopup-${sectionId}`);
      if(closeBtn) closeBtn.setAttribute('aria-label', lang==='de'?'Schließen':(lang==='en'?'Close':'Fermer'));
    })();

    // --------- Submit ---------
    const form = ROOT.querySelector(`#quiz-${sectionId}`);
    form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const answers = {};
      ['q1','q2','q3','q4','q5','q6','q7','q8'].forEach(q=>{
        const el = form.querySelector(`select[name="${q}"]`);
        if(el && el.value) answers[q]=el.value;
      });
      if(Object.keys(answers).length<8){ alert((I18N[lang]||I18N.fr).alert_all); return; }
      const ranked = scorePrenom(answers);
      const best   = DATA.find(p=>p.prenom===ranked[0][0]);
      const media  = {}; // avatar optionnel via TAG_MEDIA si tu veux

      const resBox=ROOT.querySelector(`#result-${sectionId}`); resBox.style.display='block';
      ROOT.querySelector(`#resName-${sectionId}`).textContent = best.prenom;
      ROOT.querySelector(`#resTag-${sectionId}`).textContent  = buildTagline(best);
      ROOT.querySelector(`#resPills-${sectionId}`).innerHTML  = pillText(best);

      const avatar = ROOT.querySelector(`#resAvatar-${sectionId}`);
      avatar.textContent=''; if(media.img){ avatar.style.backgroundImage=`url(${media.img})`; avatar.style.backgroundSize='cover'; avatar.style.backgroundPosition='center'; }

      ROOT.querySelector(`#openPopup-${sectionId}`).onclick=()=>openModal(best);

      const seeTop=ROOT.querySelector(`#seeTop3-${sectionId}`); const top3Div=ROOT.querySelector(`#top3-${sectionId}`);
      if(seeTop && top3Div){
        seeTop.onclick=()=>{
          const d=(I18N[lang]||I18N.fr);
          const t=ranked.slice(0,3).map(([n,s])=>`${n} (${s})`).join(' · ');
          top3Div.textContent = (d.top3_prefix||'Top 3: ')+t;
          top3Div.style.display='block';
        };
      }
      window.scrollTo({top:resBox.getBoundingClientRect().top + window.scrollY - 20, behavior:'smooth'});
    });

    // --------- Modal ---------
    function openModal(item){
      const fallback = opts?.fallbackURL || '/collections/sexdoll-lovedoll';
      const media = {}; // si tu as TAG_MEDIA[item.tag], branche-le ici

      ROOT.querySelector(`#modalTitle-${sectionId}`).textContent =
        item.prenom + ' — ' + item.etymologie.replace(/\.$/,'');

      const imgEl = ROOT.querySelector(`#modalImg-${sectionId}`);
      const body  = ROOT.querySelector(`#modalBody-${sectionId}`);
      if(media.img){ imgEl.style.display='block'; imgEl.src=media.img; body.style.gridTemplateColumns='280px 1fr'; }
      else { imgEl.style.display='none'; body.style.gridTemplateColumns='1fr'; }

      const sub = `${tr(item.region)} · ${tr(item.tonalite)} · ${tr(item.longueur)} · ${tr(item.caractere)} · ${tr(item.symbolique)}`;
      ROOT.querySelector(`#modalSub-${sectionId}`).textContent = sub;
      ROOT.querySelector(`#modalDesc-${sectionId}`).textContent = buildTagline(item);

      const link = ROOT.querySelector(`#adoptLink-${sectionId}`);
      link.href = (media.url || fallback);
      link.textContent = (I18N[lang]||I18N.fr).adopt_cta;

      ROOT.querySelector(`#overlay-${sectionId}`).style.display='flex';
    }
    ROOT.querySelector(`#closePopup-${sectionId}`).addEventListener('click',()=>{ ROOT.querySelector(`#overlay-${sectionId}`).style.display='none'; });
    ROOT.querySelector(`#overlay-${sectionId}`).addEventListener('click',(e)=>{ if(e.target.id===`overlay-${sectionId}`) e.currentTarget.style.display='none'; });

    console.log('[Quiz-AdopteLa] Ready — lang=',lang);
  };
})();
